module.exports = __webpack_public_path__ + "img/cog-white.c471c926.svg";